import {
  purgeOrphanedChakraModalLayers,
  schedulePurgeOrphanedChakraModalLayers,
} from "./chakraModalCleanup";

/** Spread onto Chakra `<Modal>` instances to avoid stuck portal layers after close. */
export const igniteChakraModalProps = {
  isCentered: true,
  motionPreset: "none" as const,
  onCloseComplete: () => purgeOrphanedChakraModalLayers({ force: true }),
};

export function wrapChakraModalOnClose(onClose: () => void) {
  return () => {
    purgeOrphanedChakraModalLayers({ force: true });
    onClose();
    schedulePurgeOrphanedChakraModalLayers();
  };
}
